<section class="rnd-page">
  <div class="rnd-header">
    <div>
      <p class="eyebrow">R&D Lab</p>
      <h1>Voice Transcription</h1>
      <p class="subtext">Record a microphone sample, play it back, then send the complete audio to the transcription worker.</p>
    </div>
    <div class="status-pill" [class.recording]="state === 'recording'" [class.failed]="state === 'failed'">
      <span></span>
      {{ statusLabel }}
    </div>
  </div>

  <div class="rnd-grid">
    <div class="panel recorder-panel">
      <div class="timer">{{ formattedDuration }}</div>
      <div class="meter" [class.live]="state === 'recording'">
        <span></span><span></span><span></span><span></span><span></span>
      </div>

      <div class="actions">
        <button type="button" class="primary" [disabled]="!canRecord" (click)="startRecording()">
          <span class="material-icons">fiber_manual_record</span>
          Start Recording
        </button>
        <button type="button" class="danger" [disabled]="!canStop" (click)="stopRecording()">
          <span class="material-icons">stop</span>
          Stop
        </button>
        <button type="button" class="ghost" [disabled]="state === 'recording' || state === 'uploading'" (click)="clear()">
          <span class="material-icons">refresh</span>
          Clear
        </button>
      </div>

      <div class="audio-box" *ngIf="audioUrl; else noAudio">
        <div class="audio-meta">
          <span>Size: {{ fileSizeLabel }}</span>
          <span>Type: {{ mimeType || 'audio/webm' }}</span>
        </div>
        <audio [src]="audioUrl" controls></audio>
      </div>

      <ng-template #noAudio>
        <div class="empty-audio">
          <span class="material-icons">mic</span>
          No recording yet
        </div>
      </ng-template>

      <button type="button" class="submit" [disabled]="!canSend" (click)="sendToTranscription()">
        <span class="material-icons">cloud_upload</span>
        {{ savingAnalysis ? 'Saving analysis...' : 'Send to Transcription' }}
      </button>
    </div>

    <div class="panel result-panel">
      <div class="panel-title">
        <span class="material-icons">subtitles</span>
        Transcription Result
      </div>

      <div class="error" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="transcript" *ngIf="transcription; else emptyTranscript">
        {{ transcription }}
      </div>

      <ng-template #emptyTranscript>
        <div class="empty-result">
          Transcription will appear here after upload.
        </div>
      </ng-template>

      <button type="button" class="raw-toggle" *ngIf="rawResponse" (click)="showRaw = !showRaw">
        {{ showRaw ? 'Hide' : 'Show' }} raw response
      </button>
      <pre class="raw" *ngIf="showRaw">{{ rawResponse }}</pre>

      <button type="button" class="raw-toggle" *ngIf="savedIntentResponse" (click)="showSavedIntent = !showSavedIntent">
        {{ showSavedIntent ? 'Hide' : 'Show' }} intent response
      </button>
      <pre class="raw" *ngIf="showSavedIntent">{{ savedIntentResponse }}</pre>
    </div>
  </div>

  <div class="panel saved-panel">
    <div class="panel-title">
      <span class="material-icons">dataset</span>
      Saved Voice Intent Records
      <button type="button" class="refresh-mini" [disabled]="recordsLoading" (click)="loadSavedRecords()">
        <span class="material-icons">refresh</span>
        Refresh
      </button>
    </div>

    <div class="empty-result" *ngIf="!recordsLoading && !savedRecords.length">
      No saved R&D voice records yet.
    </div>

    <div class="table-wrap" *ngIf="savedRecords.length">
      <table>
        <thead>
          <tr>
            <th>Recorded</th>
            <th>Audio</th>
            <th>Transcription</th>
            <th>Intent</th>
            <th>Flags</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let record of savedRecords">
            <td>
              <strong>{{ dateFor(record.recordedAt || record.createdAt) }}</strong>
              <span>{{ durationFor(record.durationSeconds) }} · {{ fileSizeFor(record.fileSizeBytes) }}</span>
            </td>
            <td class="audio-cell">
              <button type="button" class="icon-button" (click)="previewSavedAudio(record)">
                <span class="material-icons">{{ record.previewUrl ? 'close' : 'play_arrow' }}</span>
                {{ record.previewUrl ? 'Hide' : 'Play' }}
              </button>
              <audio *ngIf="record.previewUrl" [src]="record.previewUrl" controls></audio>
            </td>
            <td class="transcription-cell">{{ record.transcriptionText || '-' }}</td>
            <td>
              <strong>{{ record.intentName || '-' }}</strong>
              <span>{{ record.intentGroup || '-' }} · {{ confidenceFor(record.intentConfidence) }}</span>
            </td>
            <td>
              <div class="flag-list">
                <span [class.on]="record.intentNeedsReview">Review</span>
                <span [class.on]="record.intentRelevant">Relevant</span>
                <span [class.on]="record.intentPromotional">Promo</span>
                <span [class.on]="record.intentComplaint">Complaint</span>
              </div>
            </td>
            <td>
              <button type="button" class="delete-mini" (click)="deleteSavedRecord(record)">
                <span class="material-icons">delete</span>
                Delete
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
